import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import { Contact } from "@/components/Contact";

export default function ContactPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "Kontakt LD Media",
    description: "Book et gratis møde med LD Media eller send en besked.",
    mainEntity: {
      "@type": "Organization",
      name: "LD Media",
      email: "ldmediaa1@gmail.com",
      telephone: "+45 91 64 92 29",
    },
  };

  return (
    <>
      <SEO
        title="Kontakt"
        path="/kontakt"
        description="Kontakt LD Media i dag. Book en gratis 30-minutters analyse og find dine 3 største vækstmuligheder. Vi vender tilbage inden for 24 timer."
        jsonLd={jsonLd}
      />
      <PageHero
        eyebrow="Kontakt"
        title="Lad os tale om"
        accent="din vækst."
        subtitle="Book en gratis 30-minutters analyse, eller skriv en besked. Vi vender tilbage inden for 24 timer."
      />
      <Contact />
    </>
  );
}
